import EachQuestion from "../general/EachQuestion";
import * as theme from "../theme";

const MasterGroupOpenedQuestions = ({
  questionsOrder,
  formid,
  groupid,
  isLastGroup,
}) => {
  return (
    <div
      style={{
        minHeight: theme.SCALES.openedQuestionMinHeight,
        display: "flex",
        flexDirection: "column",
        paddingTop: theme.SCALES.paddingTopInEachQuestionList,
        paddingBottom: theme.SCALES.paddingTopInEachQuestionList,
        paddingLeft: theme.SCALES.openedQuestionsLeftPadding,
        paddingRight: theme.SCALES.openedQuestionsRightPadding,
        backgroundColor: theme.COLORS.help_tip,
        borderBottomRightRadius: isLastGroup
          ? theme.SCALES.groupTabBorderRadius
          : 0,
        borderBottomLeftRadius: isLastGroup
          ? theme.SCALES.groupTabBorderRadius
          : 0,
      }}
    >
      {questionsOrder.map((questionid) => (
        <EachQuestion
          key={`${formid}_${groupid}_${questionid}_node`}
          formid={formid}
          questionid={questionid}
        ></EachQuestion>
      ))}
    </div>
  );
};

export default MasterGroupOpenedQuestions;
